'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
export const useCopyToClipboard = t0 => {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    timeout: t2
  } = t1;
  const timeout = t2 === undefined ? 2000 : t2;
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);
  let t3;
  if ($[2] !== timeout) {
    t3 = async value => {
      if (typeof window === "undefined" || !navigator.clipboard?.writeText || !value) {
        return;
      }
      try {
        await navigator.clipboard.writeText(value);
        setCopied(true);
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => setCopied(false), timeout);
      } catch {}
    };
    $[2] = timeout;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const copy = t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    t5 = [];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== copied || $[7] !== copy) {
    t6 = {
      copied,
      copy
    };
    $[6] = copied;
    $[7] = copy;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};